import React, { type FC } from "react";
import classNames from "classnames";
import {
    formatBusinessDateText,
    type BusinessDatePreset,
    type FormatBusinessDateTextOptions,
} from "./formatBusinessDateText";

/** Пропсы компонента {@link BusinessDateValue}. */
export interface BusinessDateValueProps {
    /** ISO-дата или дата-время для read-only отображения. */
    value: string | null | undefined;
    /** Пресет формата; по умолчанию `date`. */
    preset?: BusinessDatePreset;
    /** Явный формат вместо пресета. */
    format?: FormatBusinessDateTextOptions["format"];
    /**
     * Текст или узел для пустой или невалидной даты. \
     * Если не задан, пустое значение не рендерится.
     */
    fallback?: React.ReactNode;
    /** Дополнительный CSS-класс корневого контейнера. */
    className?: string;
}

/**
 * Read-only отображение ISO-даты с пресетами бизнес-форматирования.
 *
 * @example
 * ```tsx
 * <BusinessDateValue value={order.Date} />
 * <BusinessDateValue value={movement.UserDate} preset="dateTime" />
 * ```
 */
export const BusinessDateValue: FC<BusinessDateValueProps> = ({ value, preset, format, fallback, className }) => {
    const text = formatBusinessDateText(value, { preset, format, fallback: "" });

    if (text === "") {
        if (fallback != null) {
            return <span className={classNames("business_date_value", className)}>{fallback}</span>;
        }

        return null;
    }

    return <span className={classNames("business_date_value", className)}>{text}</span>;
};
